/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Mar 27 2024
 **/

import { BaseService } from "@/frameworks/libraries/restservice";
import isEmpty from "lodash-es/isEmpty";

class UnityHttp extends BaseService {
	constructor() {
		super();
	}

	public request = (data: IPC.Commons.HttpRequest) => {
		switch (data.method) {
			case "POST":
				return this.post(data.url, data.body, !isEmpty(data.header) ? { headers: data.header } : undefined);
			case "PUT":
				return this.put(data.url, data.body, !isEmpty(data.header) ? { headers: data.header } : undefined);
			case "DELETE":
				return this.delete(data.url);
			case "GET":
			default:
				return this.get(data.url);
		}
	};
}

const UnityHttpStatic = new UnityHttp();
export default UnityHttpStatic;
